import type { LucideIcon } from 'lucide-react';
import type { SignupAccountType } from './signup-validation';
import { Building2, Layers } from 'lucide-react';

type TypeChoice = { type: SignupAccountType; title: string; description: string; Icon: LucideIcon };

// Draft copy from the design: the descriptions need product sign-off.
const CHOICES: readonly TypeChoice[] = [
  {
    type: 'Client Account',
    title: 'Client',
    description: "You grow your own company's website. One workspace for your team.",
    Icon: Building2,
  },
  {
    type: 'Agency',
    title: 'Agency',
    description:
      'You grow websites for other companies. Manage every client account from one console and switch between them.',
    Icon: Layers,
  },
];

type SignupTypeCardsProps = { onChoose: (type: SignupAccountType) => void };

/**
 * `type` values are COMPANY_TYPES verbatim ('Client Account' | 'Agency'), the
 * strings the signup endpoint validates against. The card says "Client", which is
 * what a visitor calls themselves; the payload says what the server expects.
 */
export const SignupTypeCards = ({ onChoose }: SignupTypeCardsProps) => (
  <div className="mt-[18px] ml-[38px] grid grid-cols-[repeat(auto-fit,minmax(200px,1fr))] gap-2.5 max-sm:ml-0">
    {CHOICES.map(({ type, title, description, Icon }) => (
      <button
        key={type}
        type="button"
        onClick={() => onChoose(type)}
        className="pt-bubble-in bg-panel hover:border-accent flex flex-col items-start gap-3 rounded-[16px] border border-transparent p-[18px] text-left transition-colors duration-150"
        data-from="pt"
      >
        <span className="text-accent flex h-9 w-9 items-center justify-center rounded-[10px] bg-[var(--selBg)]">
          <Icon size={18} strokeWidth={1.5} aria-hidden="true" />
        </span>
        <span className="text-foreground text-lede font-medium">{title}</span>
        <span className="text-dim text-meta leading-[1.5]">{description}</span>
      </button>
    ))}
  </div>
);
